<template>
	<v-flex xs12 v-if="documents && documents.length > 0">
		<v-flex xs12>
			<confirmation-header-text
					:text="headerText"
					icon="mdi-attachment"/>
		</v-flex>
		<v-flex xs12 class="">
			<v-layout class row>
				<v-flex xs12 class="red--text">
					Maximum upload limit for each document is 2 MB
				</v-flex>
				<v-flex md4 xs12 class="mt-2" v-for="(d,index) in documents" :key="d.name">
					<div class="already-submitted-div">
						<div v-if="allowAutofill(d)"
						     class="caption text-primary float-right"
						>
							Document has been already submitted
						</div>
					</div>
					<file-input
							:fileSize="2048"
							:label="d.name + ' (Optional)'"
							:valid_file_types="['jpg','jpeg','png','pdf','doc','docx']"
							multiple
							placeholder=""
							:disabled="allowAutofill(d)"
							v-model="extendConvertData.required_documents[d.name]"
					/>

				</v-flex>
			</v-layout>
		</v-flex>
	</v-flex>

</template>

<script>
import ConfirmationHeaderText from "../components/ConfirmationHeaderText";
import FileInput from "./FileInput";

export default {
	name: "AttachDocuments",
	props: ['documents', 'headerText'],
	components: {
		ConfirmationHeaderText,
		FileInput
	},
	computed: {
		extendConvertVisaDetail() {
			return this.$store.state.VisaSingle.extendConvertVisaDetail
		},
		extendConvertData: {
			get() {
				return this.$store.state.VisaSingle.extendConvertData
			},
			set(value) {
				return this.$store.commit("VisaSingle/setExtendConvertDataRequiredDocuments")
			}
		},
	},
	methods: {
		allowAutofill(val) {
			if (this.extendConvertVisaDetail.required_documents) {
				const hasIndex = this.extendConvertVisaDetail.required_documents.findIndex(item => item.document_type === val.name);
				return !!(hasIndex >= 0  && val.autofill === 1);
			}
			return false;
			// return this.extendConvertVisaDetail.required_documents && this.extendConvertVisaDetail.required_documents[val.name] && val.autofill === 1
		}
	},
}
</script>


<style scoped>
.already-submitted-div {
	height: 22px;
}
</style>
